import type {
  FmAnalysisAction,
  FmAnalysisSelector,
  FmAnalysisWorkspaceDescriptor,
} from '../FmAnalysisWorkspaceRoot.types';

export function analysisWorkspaceChromeActions(
  descriptor: FmAnalysisWorkspaceDescriptor,
): readonly FmAnalysisAction[] {
  if (!descriptor.map.timeSeries) return descriptor.actions;
  return descriptor.actions.filter((action) => action.group !== 'transport');
}

function isMediaSelector(selector: FmAnalysisSelector): boolean {
  return selector.id === 'source' || selector.id === 'comparison';
}

function isEvidenceSelector(selector: FmAnalysisSelector): boolean {
  return selector.id === 'subject' || selector.id === 'event';
}

/** Date and compare stay on the media; scope and event date do not. */
export function analysisWorkspaceSecondarySelectors(
  descriptor: FmAnalysisWorkspaceDescriptor,
): readonly FmAnalysisSelector[] {
  if (!descriptor.map.timeSeries) return [];
  return descriptor.selectors.filter(isMediaSelector);
}

export function analysisWorkspaceEvidenceSelectors(
  descriptor: FmAnalysisWorkspaceDescriptor,
): readonly FmAnalysisSelector[] {
  if (!descriptor.map.timeSeries) return [];
  return descriptor.selectors.filter(isEvidenceSelector);
}
